import React, { useState, useEffect } from "react";
import { Row, Col, Container } from "shards-react";
import styled from "styled-components";
import baseUrl from "config/baseUrl";
import { Loading } from "views/Indicators/components";
import { useTranslation } from "react-i18next";
import useCurrentUser from "shared/hook/useCurrentUser";
import Layout from "shared/container/Layout";


const axios = require("axios").default;

const IndicatorsContent = styled.div`
  padding: 30px 0;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  @media only screen and (max-width: 786px) {
    flex-direction: column;
    & a {
      flex: 1;
      margin: 10px 0;
    }
  }
`;
const StyledIndicatorsList = styled.a`
  border-color: #1968bc;
  color: #000;
  background-color: #eff5fb;
  padding: 15px 30px;
  border-radius: 8px;
  flex: 40%;
  margin: 10px;
  position: relative;

  i {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 10px;
    -moz-border-radius: 7.5px;
    -webkit-border-radius: 7.5px;
    border-radius: 7.5px;
    position: absolute;
    background-color: #1968bc;
    left: 10px;
    top: 20px;
  }
  :hover {
    color: #fff !important;
    text-decoration: none;
    background-color: #1968bc !important;
    i {
      background-color: #fff !important;
    }
  }
`;

const IndicatorsStyledIndicatorsListst = () => {
  const { t, i18n } = useTranslation();
  const { curruntUser } = useCurrentUser();
  const [dataindicatorsDataset, setDataindicatorsDataset] = useState(null);
  useEffect(() => {
    var data = JSON.stringify({
      params: {
        id: "",
        // "up.upId": curruntUser ? curruntUser.user.userId :null
      },
      show: 1000,
      page: 1,
      orderBy: "id",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/indicatorsDataset`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        setDataindicatorsDataset(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <Layout>
      {dataindicatorsDataset != null ? (
        <Container>
          <Row>
            <Col className="mt-5 mb-5 text-center">
              <h5 className="mb-2">
                <strong>
                  {t("common:indicatorsDetail.TotalInformationKPIs")}
                </strong>
              </h5>
              <div>{t("common:indicatorsDetail.ThailandLogistics")}</div>
            </Col>
          </Row>

          {dataindicatorsDataset.data.length > 0 && (
            <Row>
              <Col md="12">
                <IndicatorsContent>
                  {dataindicatorsDataset.data.map((item, key) => {
                    if (key < 44) {
                      return (
                        <StyledIndicatorsList
                          key={key}
                          href={`/indicators/detail/${item.id}`}
                          target="_blank"
                        >
                          <i></i>
                          {i18n.language === "th"
                            ? item.indicatorsDatasetSettingName
                            : item.indicatorsDatasetSettingNameEN ||
                              item.indicatorsDatasetSettingName}
                        </StyledIndicatorsList>
                      );
                    }
                  })}
                </IndicatorsContent>
              </Col>
            </Row>
          )}
        </Container>
      ) : (
        <Loading />
      )}
    </Layout>
  );
};

export default IndicatorsStyledIndicatorsListst;
